export const STRAPI_BRAND_COLORS = [
  'Extra Light Purple',
  'Light Gray',
  'Light Purple',
  'Medium Gray',
  'Purple Black',
  'Purple Black 10',
  'Purple Black 20',
  'Purple Black 40',
  'Purple Black 60',
  'Purple Black 80',
  'Safeguard Purple',
  'Safeguard Purple/Blue',
  'Safeguard Purple/Bright',
  'Safeguard Purple/Gray',
  'Safeguard Purple/White',
  'Safeguard White',
  'Safeguard Yellow',
  'Safeguard Yellow/Cream',
  'Safeguard Yellow/White',
  'White',
] as const;

export const HEADING_SIZE = ['h1', 'h2', 'h3', 'h4', 'h5'] as const;

export const ASTRO_LOCALES = ['en', 'es', 'fr', 'de', 'nl', 'zh'] as const;

export const STRAPI_LOCALES = [
  'en',
  'es-ES',
  'fr-FR',
  'de-DE',
  'nl-NL',
  'zh-Hans',
] as const;

export const TF_VALUE = [
  'analyze_tf',
  'contractor_tf',
  'hire_tf',
  'manage_tf',
  'pay_tf',
  'payrollexp_tf',
  'recruit_tf',
  'dk_tf',
  'geo_tf',
  'other_tf',
  'gmp_tf',
] as const;
